/* eslint-disable react/jsx-props-no-spreading,arrow-body-style */
import React from 'react';
import {
  useNavigate,
  useLocation,
} from 'react-router-dom';

const withRouterProps = (Component) => {
  return (props) => (
    <Component
      {...props}
      navigate={useNavigate()}
      location={useLocation()}
    />
  );
};

export default withRouterProps;
